// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `tr:not(:disabled):not(.disabled) {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/s1/s1-standard-search-modal/s1-standard-search-modal.component.scss"],"names":[],"mappings":"AAAA;EAAmC,eAAA;AAEnC","sourcesContent":["tr:not(:disabled):not(.disabled) { cursor: pointer; }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
